module.exports = __webpack_public_path__ + "static/media/icon_pin.8008b03e.svg";